import { put, take, select } from 'redux-saga/effects';

import { TOGGLE_NOTE } from './actions';
import { SAVE_ANNOTATION_POSITION, RESET_ANNOTATION } from 'reducers/compModels';
import { SAVE_SELECTEDHIGHLIGHT } from 'reducers/dataModels';
import { annoHeight } from "../../lib/constants";


function* toggle() {
  while (true) {
    const { data:{ position, selectedHighlight }} = yield take(TOGGLE_NOTE);
    const { innerHeight: viewportHeight, innerWidth: viewportWidth } = window;

    const prevHighlightId = yield select(state => state.selectedHighlight.id);
    const isMain = yield select(state => state.annotation.isMain);

    if ((prevHighlightId === selectedHighlight.id) && !isMain) {
      yield put({ type: RESET_ANNOTATION });
    } else {
      yield put({
        type: SAVE_SELECTEDHIGHLIGHT,
        data: selectedHighlight
      });

      let placeAnnoTop = position.y;
      let placeAnnoLeft = position.x;

      //how far off the bottom?
      const bottomOffset = viewportHeight - position.y - 5;
      if (bottomOffset <= annoHeight) {
        console.log('TOO CLOSE TO THE BOTTOM', bottomOffset);
        placeAnnoTop = placeAnnoTop - annoHeight - 35;
      }

      const annoPosition = {
        x: Math.floor(placeAnnoLeft),
        y: Math.floor(placeAnnoTop),
      };

      yield put({
        type: SAVE_ANNOTATION_POSITION,
        data: {
          isMain: false,
          isOpen: true,
          textSelected: false,
          highlightClicked: false,
          noteClicked: true,
          position: annoPosition
        }
      });
    }
  }
}

export default toggle;
